import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import warning3 from '../../assets/images/backoffice/warning3.png';
import { Checkbox } from '../../components/common/Checkbox/Checkbox';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { H3, P2 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

export const FirstLogin = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');
  const { t: dashboard } = useTranslation('dashboard');
  const [checkbox, setCheckbox] = useState(false);

  const firstLogin = async () => {
    try {
      await axios.put(`/user/set-first-login-popup-checked`);
      history.push(SETTINGS_VIRTUAL_OFFICE);
    } catch (error: any) {
      console.log(error.response);
    }
  };

  const dispatch = useDispatch();
  return (
    <div>
      <Flexed justifyCenter>
        <img src={warning3} alt='' style={{ width: 150 }} />
      </Flexed>

      <H3 center m='32px 0 10px 0'>
        Back-Office Subscription Needed
      </H3>

      <P2 m='32px 0'>
        If you haven’t purchased Back-Office Subscription <b>you </b>
        <br />
        <b>ARE NO LONGER RECEIVING</b>
      </P2>

      <P2 mb='5'>&#x274C; Business Volume Points (BV) </P2>

      <P2 mb='32'>
        &#x274C; Bonuses (Team Bonus, Matching Bonus, Direct Bonus is capped to
        100 EUR per week){' '}
      </P2>

      <Flexed mb='40' center>
        <Checkbox
          margin={'0 20px 0 0'}
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
        />
        <P2 color={colors.neutral700}>
          {' '}
          I am aware, that without BO subscription I can lose BV points
          accumulation and bonuses
        </P2>
      </Flexed>

      <Button disabled={!checkbox} onClick={firstLogin}>
        Get Back-Office subscription NOW
      </Button>
    </div>
  );
};
